export function isMobile() {
  return window.matchMedia('(max-width: 991px)').matches
}

export function createSlider({ wrapper, prevArrow, nextArrow, options }) {
  let slider = null

  if ($(wrapper).length) {
    slider = $(wrapper).slick(options)
    $(prevArrow).click(() => slider.slick('slickPrev'))
    $(nextArrow).click(() => slider.slick('slickNext'))
  }
  
  return slider
}




// WEBPACK FOOTER //
// ./scripts/func/common.js